require('./angular-canvas-ext');
module.exports = 'ap.canvas.ext';



//////////////////
// WEBPACK FOOTER
// ./~/angular-canvas-ext/index.js
// module id = 19
// module chunks = 0